import { MagicLink as SharedMagicLink } from '@avanta/shared/components/MagicLink';
import { useNavigate } from 'react-router';
import { ROUTES } from 'constants/routes';
import { AuthService } from 'services/auth';
import { useTrackingEvents } from 'tracking/hooks';
import { type AuthInfo } from 'types/auth';

export const MagicLink = (): React.ReactElement => {
  const navigate = useNavigate();
  const { trackUserLogin } = useTrackingEvents();

  const handleSuccess = (authInfo: AuthInfo): void => {
    trackUserLogin(authInfo.user);
    navigate(ROUTES.ROOT);
  };

  return (
    <SharedMagicLink
      authenticate={AuthService.login}
      loginRoute={ROUTES.LOGIN}
      onSuccess={handleSuccess}
    />
  );
};
